import * as API from "utils/api"
import HTTPStatus from "http-status"
import { push } from "react-router-redux"

const createCompanyRequest = () => ({
  type: "CREATE_COMPANY_REQUEST",
  auth: true
})

const destroyCompanyRequest = () => ({
  type: "DESTROY_COMPANY_REQUEST",
  auth: true
})

const updateCompanyRequest = () => ({
  type: "UPDATE_COMPANY_REQUEST",
  auth: true
})

const getCompaniesSuccess = (companies) => ({
  type: "GET_COMPANIES_SUCCESS",
  companies,
})
const getCompaniesBySearchSuccess = (companies) => ({
  type: "GET_COMPANIES_BY_SEARCH_SUCCESS",
  companies
})
const getCompaniesByCountyAndCategorySuccess = companies => ({
  type: "GET_COMPANIES_BY_COUNTY_AND_CATEGORY_SUCCESS",
  companies,
})

const getCompanySuccess = company => ({
  type: "GET_COMPANY_SUCCESS",
  company,
})

const createCompanySuccess = company => ({
  type: "CREATE_COMPANY_SUCCESS",
  company,
})

const destroyCompanySuccess = id => ({
  type: "DESTROY_COMPANY_SUCCESS",
  id,
})

const updateCompanySuccess = company => ({
  type: "UPDATE_COMPANY_SUCCESS",
  company,
})

const createCompanyFailure = () => ({
  type: "CREATE_COMPANY_FAILURE",
})

const getCompanyFailure = () => ({
  type: "GET_COMPANY_FAILURE",
})

const getCompaniesFailure = () => ({
  type: "GET_COMPANIES_FAILURE",
})

export const getCompanies = (pageNumber) => async dispatch => {
  const query = `/companies?`, pagenumber = `pageNumber=${pageNumber}`
  const response = await API.get(query+pagenumber)
  switch (response.status) {
    case HTTPStatus.OK:
      const companies = await response.json()
      dispatch(getCompaniesSuccess(companies))
      break

    default:
      dispatch(getCompaniesFailure())
  }
}
export const getCompaniesBySearch = (searchValue) => async dispatch => {
  const query = `/companies?`, searchvalue = `name=${searchValue}`
  const response = await API.get(`${query}${searchvalue}`)
  switch (response.status) {
    case HTTPStatus.OK:
      const companies = await response.json()
      dispatch(getCompaniesBySearchSuccess(companies))
      break

    default:
      dispatch(getCompaniesFailure())
  }
}

export const getCompaniesByCountyAndCategory = (countyId,categoryId) => async dispatch => {
  const response = await API.get(`/counties/${countyId}/category/${categoryId}/companies`)
  switch (response.status) {
    case HTTPStatus.OK:
      const companies = await response.json()
      dispatch(getCompaniesByCountyAndCategorySuccess(companies))
      break

    default:
      dispatch(getCompaniesFailure())
  }
}

export const getCompany = id => async dispatch => {
  const response = await API.get(`/companies/${id}`)

  switch (response.status) {
    case HTTPStatus.OK:
      const company = await response.json()
      dispatch(getCompanySuccess(company))
      break
    default:
      dispatch(getCompanyFailure())
      break
  }
}


export const createCompany = company => async dispatch => {
  dispatch(createCompanyRequest())
  const config = { body: JSON.stringify({ ...company }) }
  const response = await API.post("/companies", config)
  switch (response.status) {
    case HTTPStatus.CREATED:
      const createdCompany = await response.json()
      dispatch(createCompanySuccess(createdCompany))
      dispatch(push("/admin"))
      break
    default:
      dispatch(createCompanyFailure())
      break
  }
}

export const destroyCompany = id => dispatch => {
  dispatch(destroyCompanyRequest())

  dispatch(destroyCompanySuccess(id))
  API.destroy(`/companies/${id}`)
}

export const updateCompany = (id, company) => async dispatch => {
  dispatch(updateCompanyRequest())
  const config = { body: JSON.stringify({ ...company }) }
  const response = await API.patch(`/companies/${id}`, config)
  const data = await response.json()

  dispatch(updateCompanySuccess(data))
  dispatch(push("/admin"))
}



// WEBPACK FOOTER //
// src/data/companies/actions.js